// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","BurgerIcon":"Toolbar_BurgerIcon__3cuz8","Logo":"Toolbar_Logo__3Lk47"};